// VIVA-1214 — qué guía se estaba comprando cuando el navegador se fue al banco.
//
// El reto 3DS saca a la persona del sitio y la devuelve con una carga completa
// de la página: el estado de React se pierde entero, así que al volver solo
// queda lo que venga en la URL —el `payment_intent`— y no de qué guía era.
//
// Se guarda en `sessionStorage` por el mismo motivo que `postAuthRedirect`: el
// salto es una navegación real fuera del sitio y el state del router no
// sobrevive. Y muere con la pestaña, así que no deja una compra vieja esperando
// en la próxima visita.
//
// Para qué hace falta el `guideId`: al volver, la compra se confirma
// preguntándole al servidor por el estado del intento; si esa respuesta no
// trae el dato de acceso, la única otra forma de saberlo es buscar esa guía en
// mis-guias-compradas, y para eso hay que saber cuál era.

const PENDING_GUIDE_PURCHASE_KEY = "pendingGuidePurchase";

export const rememberPendingGuidePurchase = ({ paymentIntentId, guideId } = {}) => {
  try {
    if (!paymentIntentId) return;
    sessionStorage.setItem(
      PENDING_GUIDE_PURCHASE_KEY,
      JSON.stringify({ paymentIntentId: String(paymentIntentId), guideId })
    );
  } catch (error) {
    console.error("Error al guardar la compra de guía en curso:", error);
  }
};

// Devuelve la compra guardada y la borra: se usa una sola vez.
export const consumePendingGuidePurchase = () => {
  try {
    const stored = sessionStorage.getItem(PENDING_GUIDE_PURCHASE_KEY);
    sessionStorage.removeItem(PENDING_GUIDE_PURCHASE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return parsed?.paymentIntentId ? parsed : null;
  } catch (error) {
    console.error("Error al leer la compra de guía en curso:", error);
    return null;
  }
};

// La compra terminó sin salir del sitio (se pagó, se canceló o falló): el
// marcador ya no tiene a quién servir y no debe disparar una confirmación en la
// siguiente carga de esta misma pestaña.
export const forgetPendingGuidePurchase = () => {
  try {
    sessionStorage.removeItem(PENDING_GUIDE_PURCHASE_KEY);
  } catch (error) {
    console.error("Error al borrar la compra de guía en curso:", error);
  }
};
